var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginDoodle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e7cf",
    d: "M 66.042969 163.542969 C 57.242188 170.644531 50.082031 176.421875 42.453125 186.316406 C 0.0078125 241.367188 10.023438 337.078125 44.089844 351.320312 C 73.03125 363.421875 92.679688 305.570312 174.589844 278.910156 C 251.566406 253.855469 284.160156 288.6875 325.414062 256.273438 C 372.171875 219.53125 370.074219 143.519531 369.1875 111.316406 C 368.296875 79.027344 367.070312 34.625 343.957031 24.585938 C 313.972656 11.558594 293.6875 76.59375 205.820312 108.859375 C 156.304688 127.042969 115.273438 123.824219 66.042969 163.542969 Z M 66.042969 163.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDoodle);
export default __webpack_public_path__ + "static/media/LOGIN_DOODLE.2ae47b77b48016816f60c57c01427060.svg";
export { ForwardRef as ReactComponent };